import { render, staticRenderFns } from "./basecantidadcreditos.vue?vue&type=template&id=1c3ed495"
import script from "./basecantidadcreditos.vue?vue&type=script&lang=js"
export * from "./basecantidadcreditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports